import { HTTP_INTERCEPTORS, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, from, switchMap, throwError } from 'rxjs';
import { StorageService } from '../services/storage.service';
import { Router } from '@angular/router';
import { KeycloakAuthService } from '../services/keycloak-auth.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(
    private storageService: StorageService,
    private keycloakAuth: KeycloakAuthService,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.keycloakAuth.getToken();

    // const authReq = req.clone({
    //   headers: req.headers
    //     .set('Authorization', 'Bearer ' + token)
    // });
    let authReq = req;
    if (token) {
      authReq = req.clone({
        headers: req.headers
        .set('Authorization', 'Bearer ' + token),
        withCredentials: true,
      });
    }

    return next.handle(authReq).pipe(
      catchError((error) => {
        if (
          error instanceof HttpErrorResponse &&
          !req.url.includes('token') &&
          error.status === 401
        ) {
          return this.handle401Error(authReq, next);
        }
        console.error('HTTP Request Error:', (error as Error).message, 'Source:', req.url);
        return throwError(() => error);
      })
    );
  }

  private handle401Error(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.keycloakAuth.updateToken(5)).pipe(
      switchMap((updated) => {
        const token = this.keycloakAuth.getToken();
        if (updated && token) {
          const newAuthReq = request.clone({
            headers: request.headers.set('Authorization', 'Bearer ' + token),
            withCredentials: true,
          });
          return next.handle(newAuthReq);
        }
        this.storageService.saveRedirectUrl(this.router.url);
        this.keycloakAuth.logout();
        return throwError(() => new Error('Session expired'));
      }),
      catchError(() => {
        this.storageService.saveRedirectUrl(this.router.url);
        this.keycloakAuth.logout();
        return throwError(() => new Error('Session expired'));
      })
    );
  }
}

export const httpInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpRequestInterceptor, multi: true },
];
